module.exports = __webpack_public_path__ + "img/btn_close.47360c6a.png";